module.exports = __webpack_public_path__ + "img/j3.c8e75d30.png";